import { SimpleError } from '@common/errors';
import { addPropertyField, ObjectData } from '../classes/ObjectData.js';
import { PatchMap } from '../classes/Patchable.js';
import { NullableDecoder } from './NullableDecoder.js';
import { PatchOrPutDecoder } from './PatchOrPutDecoder.js';
import { PatchMapDecoder } from './PatchMapDecoder.js';
export { PatchMapDecoder } from './PatchMapDecoder.js';
export class MapDecoder {
    keyDecoder;
    valueDecoder;
    constructor(keyDecoder, valueDecoder) {
        this.keyDecoder = keyDecoder;
        this.valueDecoder = valueDecoder;
    }
    /** String dictionary entries are not metadata; historical coerced flags still select valid patch wrappers. */
    isPatchPayload(data) {
        const flag = data.optionalField('_isPatch')?.value;
        if (flag === true) {
            return true;
        }
        if (flag === 'true' || flag === 1) {
            const changes = data.optionalField('changes')?.value;
            return typeof changes === 'object' && changes !== null;
        }
        return false;
    }
    patchType() {
        const elementDecoder = this.valueDecoder;
        if (elementDecoder.patchType) {
            const patchDecoder = elementDecoder.patchType();
            return new PatchMapDecoder(this.keyDecoder, new NullableDecoder(new PatchOrPutDecoder(this.valueDecoder, patchDecoder)));
        }
        return new PatchMapDecoder(this.keyDecoder, new NullableDecoder(this.valueDecoder));
    }
    patchDefaultValue() {
        return new PatchMap();
    }
    isPatchDefaultValue(value) {
        // Note: we cannot optimize here without instanceof - because setting it to a map is not the same as setting
        // typeof is too slow, so we optimize it here
        return typeof value === 'object' && value !== null && value._isPatchMap && value.size === 0;
    }
    decodeField(value, context, currentField) {
        if (typeof value === 'object' && value !== null) {
            const map = new Map();
            for (const key of Object.keys(value)) {
                const field = addPropertyField(currentField, key);
                map.set(this.keyDecoder.decodeField ? this.keyDecoder.decodeField(key, context, field) : new ObjectData(key, context, field).decode(this.keyDecoder), this.valueDecoder.decodeField ? this.valueDecoder.decodeField(value[key], context, field) : new ObjectData(value[key], context, field).decode(this.valueDecoder));
            }
            return map;
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: `Expected an object at ${currentField}`,
            field: currentField,
        });
    }
    decode(data) {
        return this.decodeField(data.value, data.context, data.currentField);
    }
    isDefaultValue(value) {
        // typeof is too slow, so we optimize it here
        return /* value instanceof Map && */ typeof value === 'object' && value.size !== undefined && value.size === 0;
    }
    getDefaultValue() {
        return new Map();
    }
}
//# sourceMappingURL=MapDecoder.js.map